var _class, _temp2;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * @class ReactPdfJs
 */


import PdfJsLib from 'pdfjs-dist';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
var ReactPdfJs = (_temp2 = _class = function (_Component) {
  _inherits(ReactPdfJs, _Component);

  function ReactPdfJs() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReactPdfJs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      pdf: null
    }, _this.drawPDF = function (page) {
      var _this$props = _this.props,
          scale = _this$props.scale,
          rotate = _this$props.rotate; // Because this page's rotation option overwrites pdf default rotation value,
      // calculating page rotation option value from pdf default and this component prop rotate.

      var rotation = rotate === 0 ? page.rotate : page.rotate + rotate;
      var viewport = page.getViewport(scale, rotation);
      var _this2 = _this,
          canvas = _this2.canvas;
      var canvasContext = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      var renderContext = {
        canvasContext: canvasContext,
        viewport: viewport
      };
      page.render(renderContext);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReactPdfJs.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    var _props = this.props,
        file = _props.file,
        onDocumentComplete = _props.onDocumentComplete,
        page = _props.page,
        cMapUrl = _props.cMapUrl,
        cMapPacked = _props.cMapPacked,
        workerSrc = _props.workerSrc;
    PdfJsLib.GlobalWorkerOptions.workerSrc = workerSrc;
    PdfJsLib.getDocument({
      url: file,
      cMapUrl: cMapUrl,
      cMapPacked: cMapPacked
    }).then(function (pdf) {
      _this3.setState({
        pdf: pdf
      });

      if (onDocumentComplete) {
        onDocumentComplete(pdf._pdfInfo.numPages); // eslint-disable-line
      }

      pdf.getPage(page).then(function (p) {
        return _this3.drawPDF(p);
      });
    });
  };

  ReactPdfJs.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var _this4 = this;

    var _props2 = this.props,
        page = _props2.page,
        scale = _props2.scale,
        rotate = _props2.rotate;
    var pdf = this.state.pdf;

    if (newProps.page !== page || newProps.scale !== scale || newProps.rotate !== rotate) {
      pdf.getPage(newProps.page).then(function (p) {
        return _this4.drawPDF(p);
      });
    }
  };

  ReactPdfJs.prototype.render = function render() {
    var _this5 = this;

    var className = this.props.className;
    return React.createElement('canvas', {
      ref: function ref(canvas) {
        _this5.canvas = canvas;
      },
      className: className
    });
  };

  return ReactPdfJs;
}(Component), _class.defaultProps = {
  page: 1,
  onDocumentComplete: null,
  scale: 1,
  rotate: 0,
  cMapUrl: '../node_modules/pdfjs-dist/cmaps/',
  cMapPacked: false,
  workerSrc: '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.943/pdf.worker.js'
}, _temp2);
export { ReactPdfJs as default };
ReactPdfJs.propTypes = process.env.NODE_ENV !== "production" ? {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  page: PropTypes.number,
  onDocumentComplete: PropTypes.func,
  scale: PropTypes.number,
  rotate: PropTypes.oneOf([0, 90, 180, 270]),
  cMapUrl: PropTypes.string,
  cMapPacked: PropTypes.bool,
  className: PropTypes.string,
  workerSrc: PropTypes.string
} : {};